import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import { FadeUp, MaskLine } from "../components/site/Reveal";

export default function Insights() {
    const navigate = useNavigate();

    return (
        <div className="grain bg-navy-deep" data-testid="insights-page">
            <Header />
            <main>
                <section className="relative flex min-h-[72vh] items-center overflow-hidden pt-[76px]">
                    <div className="hero-grid pointer-events-none absolute inset-0" aria-hidden="true" />
                    <div className="relative mx-auto w-full max-w-[1440px] px-5 py-20 lg:px-10">
                        <FadeUp>
                            <div className="flex items-center gap-4">
                                <span className="h-px w-12 bg-gold" aria-hidden="true" />
                                <span className="text-[11px] font-semibold uppercase tracking-[0.34em] text-gold sm:text-xs">
                                    Viet Medica Ltd
                                </span>
                            </div>
                        </FadeUp>
                        <h1 className="mt-8 font-serif text-4xl font-light leading-[1.08] tracking-tight text-ivory sm:text-5xl lg:text-6xl">
                            <MaskLine delay={0.2}>Insights</MaskLine>
                        </h1>
                        <FadeUp delay={0.4}>
                            <p className="mt-4 font-serif text-xl font-light italic text-gold lg:text-2xl">
                                Market notes and healthcare guidance — publishing soon.
                            </p>
                            <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-300/85 md:text-lg">
                                The Viet Medica team is preparing market notes, healthcare guidance and
                                international trading perspectives from across our network. Published articles
                                will appear on this page.
                            </p>
                            <button
                                type="button"
                                data-testid="insights-home-button"
                                onClick={() => navigate("/")}
                                className="group mt-10 inline-flex items-center gap-3 border border-gold/50 px-6 py-3.5 text-xs font-bold uppercase tracking-[0.18em] text-gold transition-colors duration-300 hover:bg-gold hover:text-navy-deep"
                            >
                                Return to Homepage
                                <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                            </button>
                        </FadeUp>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
